import {Component, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import {ToolsService} from '../../services/tools.service';
import {ModalInterface} from '../modal-basic/ModalInterface';

@Component({
  selector: 'app-modal-resumen-carga-archivos',
  templateUrl: './modal-resumen-carga-archivos.component.html',
  styleUrls: ['./modal-resumen-carga-archivos.component.scss']
})
export class ModalResumenCargaArchivosComponent extends ModalInterface  implements OnInit {
  
  @ViewChild('dxDtgData') oDxDataGridComponent: DxDataGridComponent;
  iSelPageSize: number;
  lsPageSize: number[] = [];
  lsObservacion = [
    {value: 'C', label: 'CREADO'},
    {value: 'NC', label: 'NO CREADO'},
  ];
  constructor(
    public tools: ToolsService,
  ) {
    super();
    this.lsPageSize = this.tools.getLimitPageSize();
    this.iSelPageSize = this.lsPageSize[1];
  }
  
  ngOnInit() {
  }

}
